import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';

import FormSelect from 'retired/FormSelect';

const SectionsSelector = ({ sections, input, isSurvey, ...rest }) => (
  <FormSelect input={{ ...input, value: input.value || '-' }} {...rest}>
    <MenuItem value="-">Continue to next section</MenuItem>
    {sections.map((section) => (
      <MenuItem key={section.get('_id')} value={section.get('_id')}>
        Go to section ‘{section.get('title')}’
      </MenuItem>
    ))}
    <MenuItem value="SUBMIT">Submit {isSurvey ? 'survey' : 'form'}</MenuItem>
  </FormSelect>
);
SectionsSelector.propTypes = {
  showSubmitOption: PropTypes.bool,
  sections: PropTypes.object,
  input: PropTypes.object,
  isSurvey: PropTypes.bool,
};
export default SectionsSelector;
